
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/sitemap",
      function () {
        return require("private-next-pages/de/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/sitemap"])
      });
    }
  